/**
 * 伽马相机
 */
import instance from '@/utils/axios';

export function getGcameraList(data) {
  return instance.post('/devicedata/hisGcameraPic', { ...data });
}
